import api from "app/api";
import { Options } from "common";

export interface ReviewEmailSentItem {
  id: number;
  booking_id: number;
  email: string;
  sent_at: string;
  start_time: string;
  booking_name: string;
  template_used?: string;
  created_at: string;
  updated_at: string;
}

export type ReviewEmailSentOptions = Options<"booking_id" | "template_used">;

export function getReviewEmailSentService(scope?: any) {
  return api.getService<
    ReviewEmailSentItem,
    ReviewEmailSentItem,
    ReviewEmailSentOptions
  >("review-email-sents", {
    scope,
    //params goes here
  });
}
